var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [
        _vm._v(" " + _vm._s(_vm.$ct("background-extra-settings")) + " "),
      ]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("hide-background-image-on-print") },
                    model: {
                      value: _vm.HideBackgroundImageOnPrint,
                      callback: function ($$v) {
                        _vm.HideBackgroundImageOnPrint = $$v
                      },
                      expression: "HideBackgroundImageOnPrint",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("hide-background-image-on-email") },
                    model: {
                      value: _vm.HideBackgroundImageOnEmail,
                      callback: function ($$v) {
                        _vm.HideBackgroundImageOnEmail = $$v
                      },
                      expression: "HideBackgroundImageOnEmail",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      label: _vm.$ct("hide-background-image-on-download"),
                    },
                    model: {
                      value: _vm.HideBackgroundImageOnDownload,
                      callback: function ($$v) {
                        _vm.HideBackgroundImageOnDownload = $$v
                      },
                      expression: "HideBackgroundImageOnDownload",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }